import React from 'react';
import { Parallax } from "react-parallax";
import { format } from 'date-fns';

const ExameTopo = ({ foto, titulo, dataExame }) => {
    return(
        <>
            <Parallax className="p-0" bgImage={foto} strength={300}> 
                <div className="spacer-30"></div>
                <div className="container position-relative ">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="spacer-30"></div>
                            <div className="col-lg-12 col-md-6 mb-sm-20" >
                            <div className="spacer-150"></div>
                            </div>
                            <div className="spacer-60"></div>
                        </div>
                        <div className="spacer-60"></div>
                    </div>
                    <div className="spacer-150"></div>
                </div>
            </Parallax>
            <div className="container position-relative ">
                <h2 className="wow fadeInUp" data-wow-delay=".2s"> {titulo}</h2>
                <div className="spacer-30"></div>
                <p className="wow fadeInUp">
                {dataExame && !isNaN(new Date(dataExame).getTime())
                    ? 'Data do Exame ' + format(new Date(dataExame), 'dd/MM/yyyy')
                    : ''}
                </p>
            </div>
        </>
    );
}

export default ExameTopo;